import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';

function SearchBar({ searchTerm, setSearchTerm, getEvents, getNews }) {
    const { t } = useTranslation();

    const handleChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSearchClick = () => {
        searchEvent();
        searchNews();
    };

    const handleSearch = (event) => {
        if (event.key === 'Enter') {
            searchEvent();
            searchNews();
        }
    }

    const removeSearch = () => {
        setSearchTerm('');
        getEvents();
        getNews();
    }

    function searchEvent() {
        getEvents();
    }

    function searchNews() {
        getNews();
    }

    return (
        <TextField
            variant="outlined"
            placeholder={t("EventsPage.Search...")}
            value={searchTerm}
            onChange={handleChange}
            color={'primary'}
            onKeyDown={handleSearch}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        {searchTerm && (
                            <IconButton onClick={removeSearch}>
                                <ClearIcon />
                            </IconButton>
                        )}
                        <IconButton onClick={handleSearchClick}>
                            <SearchIcon />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            fullWidth
        />
    );
}

export default SearchBar;
